import getQueryString from 'bjxy-common/helper/getQueryString'

//百度关键词留存
function initBaiduKeyword() {
  var baiduChannel = getQueryString("channel_content");
  if(baiduChannel) {
    const cookieDomain = window.location.host.indexOf("xiaoying.com") == -1 ? ".yingzt.com" : ".xiaoying.com";
    document.cookie = `baiduChannel=${baiduChannel};domain=${cookieDomain};Session;path=/ `;
  }
};

//360关键词留存
function initQihuKeyword() {
  var plan     = getQueryString("360plan");
  var group    = getQueryString("360group");
  var creative = getQueryString("360creative");
  var keyword  = getQueryString("360keyword");
  var device   = getQueryString("360device");
  if(keyword) {//有keyword 即可落地
    var qihuChannel  = plan + "_" + group + "_" + creative + "_" + keyword + "_" + device;
    const cookieDomain = window.location.host.indexOf("xiaoying.com") == -1 ? ".yingzt.com" : ".xiaoying.com";
    document.cookie = `qihuChannel=${qihuChannel};domain=${cookieDomain};Session;path=/ `
  }
};

//搜狗关键词留存
function initSogoKeyword() {
  var keyword  = getQueryString("sogokeyword");
  var creative = getQueryString("creative");
  if(keyword) {//三个要素同时存在才落地a
    var sogoChannel  = keyword + "_" + creative;
    const cookieDomain = window.location.host.indexOf("xiaoying.com") == -1 ? ".yingzt.com" : ".xiaoying.com";
    document.cookie = `sogoChannel=${sogoChannel};domain=${cookieDomain};Session;path=/ `
  }
};

initBaiduKeyword()
initQihuKeyword()
initSogoKeyword()